// How a proposed rule change's action reads, on every surface that lists one.
export const RULE_ACTION: Record<string, string> = {
  add: "a new rule",
  update: "a change to",
  retire: "retiring",
};
